module.exports = __webpack_public_path__ + "static/media/person_pin.9cd2b68c.svg";